import React from "react";
import { IcHyperLink } from "../../common/svg";

export default class LinkGoogle extends React.Component {
    openGgLink = () => {
        window.miotoLink.openPopup('google');
        return false;
    }

    render() {
        return (
            <div className="name" onClick={this.openGgLink} >
                Thêm liên kết 
                <div className="wrap-svg"><IcHyperLink /></div>
            </div>
        );
    }
}